import React from "react";

// ---------------------------------------------------------------------------
// Next io — brand wordmark.
//
// The wordmark IS the logo. No icon, no monogram, no ribbon.
// "Next"  → deep charcoal
// " io"   → dark crimson (accent)
//
// Rendered with the Inter font family (loaded from Google Fonts in index.html).
// ---------------------------------------------------------------------------
const SIZE_CLASSES = {
  xs: "text-base",
  sm: "text-lg",
  md: "text-2xl",
  lg: "text-4xl sm:text-5xl",
  xl: "text-5xl sm:text-6xl",
};

export function Wordmark({
  size = "md",
  showTagline = false,
  taglineOverride,
  className = "",
  as: Component = "div",
  ...rest
}) {
  const sizeCls = SIZE_CLASSES[size] || SIZE_CLASSES.md;
  return (
    <Component
      className={`brand-wordmark inline-flex flex-col ${className}`}
      {...rest}
    >
      <span
        className={`brand-wordmark__mark ${sizeCls} font-medium tracking-tight leading-none`}
        aria-label="Next io"
      >
        <span className="brand-wordmark__next">Next</span>
        <span className="brand-wordmark__space">&nbsp;</span>
        <span className="brand-wordmark__io">io</span>
      </span>
      {showTagline && (
        <span className="brand-wordmark__tagline mt-1.5 text-[10px] sm:text-[11px] tracking-[0.22em] uppercase text-muted-foreground font-medium">
          {taglineOverride || "AI Business Development Employee"}
        </span>
      )}
    </Component>
  );
}

// Small "io" mark — used for tight spaces (mobile top bar, favicon-parity, etc.)
export function IoMark({ size = "md", className = "", ...rest }) {
  const sizeCls = SIZE_CLASSES[size] || SIZE_CLASSES.md;
  return (
    <span
      className={`brand-io-mark ${sizeCls} font-medium tracking-tight leading-none ${className}`}
      aria-label="Next io"
      {...rest}
    >
      io
    </span>
  );
}

export default Wordmark;
